import { FormattedMessage, useIntl } from 'react-intl';

interface DateOrdinalProps {
  date: string | Date;
}

const localeFormats = {
  it: {
    message: '{day} {month} {year}',
    values: (day: string, month: string, year: string) => ({
      day,
      month,
      year,
    }),
  },
  ja: {
    message: '{year}{month}{day}',
    values: (day: string, month: string, year: string) => ({
      year,
      month,
      day,
    }),
  },
  default: {
    message:
      '{month} {day, selectordinal, one {#st} two {#nd} few {#rd} other {#th}}, {year}',
    values: (day: string, month: string, year: string) => ({
      month,
      day,
      year,
    }),
  },
};

export const DateOrdinal = ({ date }: DateOrdinalProps) => {
  const { formatDate, locale } = useIntl();

  const day = formatDate(date, { day: 'numeric' });
  const month = formatDate(date, { month: 'long' });
  const year = formatDate(date, { year: 'numeric' });

  const localePrefix = locale.split('-')[0];

  const format =
    localeFormats[localePrefix as keyof typeof localeFormats] ||
    localeFormats.default;

  return (
    <FormattedMessage
      data-test-id='DateOrdinalFormattedMessage'
      defaultMessage={format.message}
      id='DateOrdinal'
      values={format.values(day, month, year)}
    />
  );
};
